/* eslint-disable */
import axios from "axios";
import store from "../../store";
import customModal from "../customModal/customModal.vue";


export default {
  name: "RbqmThresholdViewModal",
  components: { customModal },
  props: {
    type: String,
    data: Object
  },
  computed: {
    modalTitle() {
      if (this.type === "thresholds") return "Thresholds";
      if (this.type === "riskLevels") return "Risk Levels";
      if (this.type === "criticalDataPoints") return "Critical Data Points";
      return "View";
    },
    thresholdsData() {
      return Array.isArray(this.data?.thresholds) ? this.data.thresholds : [];
    },
    riskLevelsData() {
      return Array.isArray(this.data?.riskLevelRules) ? this.data.riskLevelRules : [];
    },
    criticalDataPointsData() {
      return Array.isArray(this.data?.criticalDataPoints) ? this.data.criticalDataPoints : [];
    }
  }
};
